import { render, staticRenderFns } from "./Setup.vue?vue&type=template&id=7f7d3e04"
import script from "./Setup.vue?vue&type=script&lang=ts"
export * from "./Setup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports